import { Box, styledStitches } from "@/app/design-system";

export const StyledUpcomingConflictsCard = styledStitches(Box, {
  px: 12,
  py: 16,
  backgroundColor: "$neutral3",
  br: 4,
});
